import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { ContactsSyncApi } from '../api/ContactsSyncApi';
import ContactForm from '../components/forms/ContactForm';
import ContactsSpinner from '../components/ContactsSpinner';
import { IUContactsActionType, useContactsContext } from '../contexts/ContactsContext';
import { useErrorContext } from '../contexts/ErrorContext';
import { useUserContext } from '../contexts/UserContext';
import { ContentContainer, FormContainer, ScrollableContent } from '../components/styled';

import { TAppContact } from 'TProtocol/common/models';
import ContactHelper from '../core/libs/ContactHelper';

function AddContact() {
  const navigate = useNavigate();
  const errorContext = useErrorContext();
  const userContext = useUserContext();
  const contactsContext = useContactsContext();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (contact: TAppContact) => {
    setLoading(true);

    try {
      await ContactsSyncApi.addContact(userContext.getAuthHeader(), contact);
      contactsContext.updateContacts([IUContactsActionType.Add, contact]);
      setLoading(false);
      navigate('/contacts');
    } catch (e) {
      errorContext.error('Something went wrong, please try again.');
    }
  };

  useEffect(() => {
    const contact = new TAppContact({});
    ContactHelper.incrementClientEditSeqId(contact);
    contactsContext.setContactToEdit(contact);
  }, []);

  return (
    <>
      <ContentContainer>
        <ScrollableContent>
          <FormContainer>
            {!loading ? <ContactForm popup={false} onSubmit={onSubmit}/> : <ContactsSpinner/>}
          </FormContainer>
        </ScrollableContent>
      </ContentContainer>
    </>
  );
}

export default AddContact;


